import { Container, Grid, makeStyles } from "@material-ui/core";
import React from "react";
import WebtoonNext from "./WebtoonNext";
import WebtoonPrev from "./WebtoonPrev";

interface WebtoonNavigationProps {
  id: any;
  parentId: any;
}
const useStyles = makeStyles((theme) => ({
  webtoonNav: {
    position: "fixed",
    top: "50%",
  },
}));
function WebtoonNavigation({ id, parentId }: WebtoonNavigationProps) {
  const classes = useStyles();
  return (
    <Container maxWidth={false} className={classes.webtoonNav}>
      <Grid xs={12} item>
        <WebtoonPrev id={id} parentId={parentId} />
        <WebtoonNext id={id} parentId={parentId} />
      </Grid>
    </Container>
  );
}

export default WebtoonNavigation;
